export function shortenDensityUnit(unit: string): string {
  // grams, ounces, teaspoons, tablespoons, cups
  switch (unit) {
    case 'grams':
      return 'g';
    case 'ounces':
      return 'oz';
    case 'teaspoons':
      return 'tsp';
    case 'tablespoons':
      return 'tbsp';
    case 'cups':
      return 'c';
    default:
      return unit;
  }
}
